// extracted by mini-css-extract-plugin
export var badge = "_ga-2";
export var detailsPanel = "_ga-0";
export var resultRow = "_ga-1";